import { render } from '@wordpress/element';
import App from './components/App';

document.addEventListener('DOMContentLoaded', () => {
    const rootElement = document.getElementById('cfafwr_admin_app');
    if (rootElement) {
        render(<App />, rootElement);
    }
});
